/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPlatformResVo } from './BusinessPlatformResVo';
import {
    BusinessPlatformResVoFromJSON,
    BusinessPlatformResVoFromJSONTyped,
    BusinessPlatformResVoToJSON,
    BusinessPlatformResVoToJSONTyped,
} from './BusinessPlatformResVo';

/**
 * 
 * @export
 * @interface ResponseListBusinessPlatformResVo
 */
export interface ResponseListBusinessPlatformResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBusinessPlatformResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBusinessPlatformResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<BusinessPlatformResVo>}
     * @memberof ResponseListBusinessPlatformResVo
     */
    data?: Array<BusinessPlatformResVo>;
}

/**
 * Check if a given object implements the ResponseListBusinessPlatformResVo interface.
 */
export function instanceOfResponseListBusinessPlatformResVo(value: object): value is ResponseListBusinessPlatformResVo {
    return true;
}

export function ResponseListBusinessPlatformResVoFromJSON(json: any): ResponseListBusinessPlatformResVo {
    return ResponseListBusinessPlatformResVoFromJSONTyped(json, false);
}

export function ResponseListBusinessPlatformResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBusinessPlatformResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BusinessPlatformResVoFromJSON)),
    };
}

export function ResponseListBusinessPlatformResVoToJSON(json: any): ResponseListBusinessPlatformResVo {
    return ResponseListBusinessPlatformResVoToJSONTyped(json, false);
}

export function ResponseListBusinessPlatformResVoToJSONTyped(value?: ResponseListBusinessPlatformResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BusinessPlatformResVoToJSON)),
    };
}

